import { render, staticRenderFns } from "./StudentCourseGroupedByCity.vue?vue&type=template&id=0c9408b3"
import script from "./StudentCourseGroupedByCity.vue?vue&type=script&lang=js"
export * from "./StudentCourseGroupedByCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports